class SlideScroll{
    constructor(opts){
        this.opts = $.extend(false ,{
            el:"#contents"
        }, opts);

        this.$el = $(this.opts.el);
        this.$header = this.$el.find("[data-header]");
        this.$cover = this.$el.find("[data-cover]");
        this.$wrap = this.$cover.find("[data-sec='wrap']");
        this.$btn = this.$el.find("[data-btn]");

        this.currStr = "";
        this.startStr = false;
        this.mainTimeline = new TimelineMax({paused:true});

        this._init();
    }

    _init(){
        this._settings();
        this._settingsAnimation();
        this._controls();
        this.resize();
    }

    _settings(){
        TweenMax.set(this.$header, {x:"0%"});
        TweenMax.set(this.$cover, {x:"100%"});
        if(window.location.hash){
            if(`${this.strConversion(window.location.hash)}`==="coupon") this.startStr = true;
            this.slideAnimation(`${this.strConversion(window.location.hash)}`);
        }else{
            this.slideAnimation("main");
        }
    }

    _settingsAnimation(){
        this.mainTimeline
            .fromTo($(".p-main__stit1"), 1.0, {y:100, autoAlpha:0}, {y:0, autoAlpha:1, ease:Power1.easeOut}, "+=0.8")
            .fromTo($(".p-main__tit"), 1.0, {y:100, autoAlpha:0}, {y:0, autoAlpha:1, ease:Power1.easeOut}, "-=0.75")
            .fromTo($(".p-main__stit2"), 1.0, {y:100, autoAlpha:0}, {y:0, autoAlpha:1, ease:Power1.easeOut}, "-=0.75")
            .fromTo($(".cht-select__list1"), 1.0, {x:100, autoAlpha:0}, {x:0, autoAlpha:1, ease:Power1.easeOut}, "-=0.50")
            .fromTo($(".cht-select__list2"), 1.0, {x:100, autoAlpha:0}, {x:0, autoAlpha:1, ease:Power1.easeOut}, "-=0.85")
            .fromTo($(".cht-select__list3"), 1.0, {x:100, autoAlpha:0}, {x:0, autoAlpha:1, ease:Power1.easeOut}, "-=0.85")
            .fromTo($(".cht-select__list4"), 1.0, {x:100, autoAlpha:0}, {x:0, autoAlpha:1, ease:Power1.easeOut}, "-=0.85")
            .fromTo($(".other"), 1.0, {y:100, autoAlpha:0}, {y:0, autoAlpha:1, ease:Power1.easeOut}, "-=0.65");
    }

    strConversion(str){
        return str.replace(/#/,"");
    }

    _controls(){
        this.$btn.on("click", (evt)=>{
            this.action(evt);
        });
    }

    resize(){
        $(window).on("resize", ()=>{
            if(this.currStr==="main") return;
            TweenMax.set(this.$el, {height:this.heightSet(this.$wrap)});
        });
    }

    heightSet(ele){
        let eleHeight = "";
        if(ele===this.$wrap){
            if($(window).height()>ele.height()){
                eleHeight = "100%";
            }else{
                eleHeight = ele.height();
            }
        }
        return eleHeight;
    }

    action(evt){
        switch(evt.target.dataset.btn){
            case "coupon":
                this.slideAnimation("coupon");
                break;
            case "main":
                this.slideAnimation("main");
                break;
        }
    }

    slideAnimation(str){
        let headerX = (str==="coupon") ? "-100%" : "0%" ;
        let secX = (str==="coupon") ? "0%" : "100%" ;
        if(str==="main") this.mainTimeline.play();
        this.currStr = str;
        if(!this.startStr) {
            this.startStr = true;
            return;
        }
        TweenMax.to(this.$el, 0.8, {height:"100%"});
        TweenMax.to([this.$header, this.$cover], 0.3, {scaleX:0.95, scaleY:0.95, ease:Power3.easeOut, onComplete:()=>{
                TweenMax.to(this.$header, 0.8, {x:headerX, onComplete:()=>{
                        this.contentsSet(str);
                    }
                });
                TweenMax.to(this.$cover, 0.8, {x:secX});
            }
        });
    }

    contentsSet(str){
        let conHeight;
        TweenMax.to([this.$header, this.$cover], 0.3, {scaleX:1.0, scaleY:1.0, onComplete:()=>{
                switch (str) {
                    case "coupon":
                        conHeight = this.heightSet(this.$wrap);
                        break;
                    case "main":
                        conHeight = "100%";
                        break;
                }
                window.location.hash = str;
                TweenMax.to(this.$el, 0.8, {height:conHeight});
            }
        });
    }
}

export default SlideScroll;


// WEBPACK FOOTER //
// ./src/js/util/slide-scroll.js